import * as React from 'react';
export const deutschekreditbankSvg = React.forwardRef(
  function deutschekreditbankSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fill: 'none',
          fillRule: 'evenodd',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#128DD0',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          fillRule: 'nonzero',
          d: 'M25.4 11.64c1.77 0 3 1.1 3 2.54 0 .96-.34 1.78-1.07 2 .61.29 1.6 1.14 1.6 2.51 0 2.04-1.5 3.13-3.13 3.13h-3.98V11.64h3.58zm.46 3.3c0-.55-.4-.9-.87-.9h-.82v1.79H25c.47 0 .86-.32.86-.9zm-.6 4.57c.53 0 .85-.46.85-1.02s-.43-1.02-.99-1.04h-.95v2.04h1.08v.02zm-12.83-7.87h2.85v3.8h.02l2.15-3.8h3.13l-2.85 4.65 3.12 5.53h-3.12l-2.43-4.4h-.02v4.4h-2.85V11.64zm-9.52 0h3.81a4.83 4.83 0 0 1 4.76 5.09 5.05 5.05 0 0 1-4.76 5.09H2.91V11.64zm2.37 2.54v5.08c1.5 0 3.13-.44 3.13-2.55 0-2.1-1.63-2.53-3.13-2.53z',
        }),
      ),
    );
  },
);
deutschekreditbankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var deutschekreditbank = {
  category: 'brand',
  colorable: false,
  name: 'deutschekreditbank',
  svg: deutschekreditbankSvg,
};
